/**
 * Подготовка полей родителя.
 * Метод проходит по полям формы (fields) и ищет соответствующие поля родителя (parentFields)
 *
 * @param {FieldsClass} parentFields Поля родителя.
 * @param {FieldClass[]} fields Поля формы
 */

import { SectionsClass } from '@/api/fields'

interface ParentFieldValue {
  ParentFieldName: string
  Value?: unknown
}

export const prepareParentFields = (
  parentFields: SectionsClass,
  fields: ParentFieldValue[],
  parentEntityType: string,
  routeParams: { params: { uuid: string }, name: string },
  parentUuid = ''
) => {
  const resolvedParentUuid = parentUuid || routeParams.params.uuid

  fields.forEach((field) => {
    if (field.ParentFieldName === 'Uuid') {
      field.Value = resolvedParentUuid
    } else if (field.ParentFieldName === 'Type') {
      field.Value = parentEntityType
    } else {
      const parentField = parentFields.getFieldByName(field.ParentFieldName)

      if (parentField) {
        field.Value = parentField.value as string
      }
    }
  })
}
